import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import {
  addNavigate,
  addOptionalQueryParam,
} from 'shared/src/utils/addNavigate'

import { IconButton } from 'components/IconButton'
import { SANS_SERIF_FONT_FAMILY } from 'components/styles'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { SetPassword } from './SetPassword'

const useStyles = createUseStyles({
  container: {
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 24,
  },
  text: {
    fontFamily: SANS_SERIF_FONT_FAMILY,
    fontSize: 16,
    color: 'rgba(144, 115, 79, 0.8)',
    marginRight: 30,
    marginLeft: 30,
    marginTop: 30,
  },
  backButton: {
    background: 'none',
    border: 'none',
    padding: 0,
  },
})

export const UpdatePassword: FC = flowMax(
  addDisplayName('UpdatePassword'),
  addOptionalQueryParam('email'),
  addOptionalQueryParam('code'),
  addProps(({ email, code }) => ({
    invalidUpdateLink: !email || !code,
  })),
  addNavigate,
  addHandlers({
    onBack:
      ({ navigate }) =>
      () => {
        navigate('/login')
      },
  }),
  addTranslationHelpers,
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ email, code, invalidUpdateLink, onBack, classes, t }) => (
    <div>
      <div className={classes.container}>
        <div>
          <IconButton name="backRodeo" onClick={onBack} />
        </div>
        {invalidUpdateLink || !email ? (
          <div className={classes.text}>
            {t('auth.recoverPassword.missingDetailsError')}
          </div>
        ) : (
          <SetPassword email={email} isUpdate code={code} />
        )}
      </div>
    </div>
  )
)
